import {
  Alert,
  Box,
  Button,
  FormControl,
  Modal,
  Snackbar,
  Typography,
  Checkbox,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  ListItemText
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useState } from 'react';
import { LoadingButton } from '@mui/lab';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ConfirmAlertDialog from '../../ConfirmDialog';
import { SendDeviceUnlockCommand } from '../../../network/Trip';
import UnlockDeviceMessageDialog from './UnlockDeviceMessageDialog';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  // minWidth: 400,
  minWidth: { xs: '60%', sm: '350px' },
  bgcolor: 'background.paper',
  // border: '1px solid #000',
  // boxShadow: 24,
  p: '16px',
  borderRadius: 1
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

const useStyles = makeStyles((theme) => ({
  menuItem: {
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    },
    minHeight: '20px',
    borderRadius: '8px',
    marginInline: theme.spacing(1)
  }
}));

export default function UnlockDeviceModal({ openAssignedModal, setUnlockModalIsOpen, devices }) {
  const classes = useStyles();
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [openConfirmAlertDialog, setOpenConfirmAlertDialog] = useState(false);
  const [error, setError] = useState(false);
  const [responseLoader, setResponseLoader] = useState(false);
  const [responseData, setResponseData] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [confirmAlertDialogMetas, setConfirmAlertDialogMetas] = useState({
    message: '',
    title: '',
    positiveBtnLable: '',
    negativeBtnLabel: ''
  });
  const [alertMetas, setAlertMetas] = useState({
    snackBarOpened: false,
    vertical: 'top',
    horizontal: 'right',
    msg: '',
    variant: 'filled',
    severity: ''
  });

  const vertical = 'bottom';
  const horizontal = 'left';

  const handleSnackBarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlertMetas({ ...alertMetas, snackBarOpened: false });
  };

  const handleChange = (event) => {
    const {
      target: { value }
    } = event;
    setSelectedDevices(typeof value === 'string' ? value.split(',') : value);
    setSelectAll(value?.length === devices?.length);
  };

  const handleSelectAll = (event) => {
    if (event?.target?.checked) {
      setSelectedDevices(devices.map((device) => device?.lock_id));
      setSelectAll(true);
    } else {
      setSelectedDevices([]);
      setSelectAll(false);
    }
  };

  const unlockSmartLocketDevice = async (deviceIds) => {
    const payload = {
      deviceIds
    };
    setResponseLoader(true);
    try {
      const res = await SendDeviceUnlockCommand(payload);
      if (res) {
        setResponseData(res?.data?.data);
        setOpenDialog(true);
      }
    } catch (error) {
      handleModalClose();
      setOpenDialog(false);
      setAlertMetas({
        ...alertMetas,
        severity: 'error',
        snackBarOpened: true,
        msg: error?.response?.data?.message
      });
      setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
    } finally {
      setResponseLoader(false);
    }
  };

  const handleModalClose = () => {
    setUnlockModalIsOpen(false);
    setSelectedDevices([]);
    setSelectAll(false);
  };

  const handleUnlockDevice = () => {
    if (selectedDevices?.length === 0) {
      setError(true);
    } else {
      setError(false);
      setConfirmAlertDialogMetas({
        ...confirmAlertDialogMetas,
        message: 'Are you sure you want to unlock these devices?',
        title: 'Unlock Devices',
        positiveBtnLable: 'Confirm',
        negativeBtnLabel: 'Cancel'
      });
      setOpenConfirmAlertDialog(true);
    }
  };

  return (
    <Box>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={alertMetas?.snackBarOpened}
        onClose={handleSnackBarClose}
        autoHideDuration={6000}
      >
        <Alert variant={alertMetas?.variant} severity={alertMetas?.severity}>
          {alertMetas?.msg}
        </Alert>
      </Snackbar>
      <Modal
        open={openAssignedModal}
        onClose={handleModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography sx={{ fontSize: { xs: 16, sm: 18 }, fontWeight: 900, mb: 2 }}>
            Unlock devices
          </Typography>
          <div>
            <FormControl sx={{ width: '100%' }}>
              <InputLabel
                id="demo-multiple-checkbox-label"
                sx={{ fontSize: { xs: '12px', sm: '14px' }, fontWeight: '500' }}
              >
                Select Devices to Unlock
              </InputLabel>
              <Select
                fullWidth
                sx={{ fontSize: { xs: '12px', sm: '14px' }, fontWeight: '500' }}
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                value={selectedDevices}
                onChange={handleChange}
                IconComponent={ExpandMoreIcon}
                input={<OutlinedInput label="Select Devices to Unlock" />}
                renderValue={(selected) =>
                  selected
                    .map((id) => devices.find((device) => device?.lock_id === id)?.name)
                    .join(', ')
                }
                MenuProps={MenuProps}
              >
                <MenuItem className={classes.menuItem}>
                  <ListItemText
                    sx={{ fontSize: { xs: '12px', sm: '14px' } }}
                    primary="Select All"
                  />
                  <Checkbox checked={selectAll} onChange={handleSelectAll} />
                </MenuItem>
                {devices?.map((item) => (
                  <MenuItem className={classes.menuItem} key={item?.id} value={item?.lock_id}>
                    <ListItemText
                      sx={{ fontSize: { xs: '12px', sm: '14px' } }}
                      primary={item?.name}
                    />
                    <Checkbox checked={selectedDevices?.indexOf(item?.lock_id) > -1} />
                  </MenuItem>
                ))}
              </Select>
              {error && selectedDevices?.length === 0 ? (
                <Typography
                  sx={{ fontSize: { xs: '12px', sm: '14px' }, color: 'red', marginTop: '5px' }}
                >
                  Please Select Device
                </Typography>
              ) : (
                ''
              )}
            </FormControl>
          </div>
          <Box sx={{ textAlign: 'right', width: '100%', mt: 3 }}>
            <Button
              type="button"
              size="small"
              variant="outlined"
              sx={{ mr: 2 }}
              onClick={handleModalClose}
            >
              Cancel
            </Button>
            <LoadingButton
              type="submit"
              size="small"
              variant="contained"
              loading={responseLoader}
              onClick={handleUnlockDevice}
            >
              Unlock
            </LoadingButton>
            {/* <Button type="submit" variant="contained" onClick={handleUnlockDevice}>
              {responseLoader ? '' : 'Unlock'}
            </Button> */}
          </Box>
          <ConfirmAlertDialog
            openConfirmAlertDialog={openConfirmAlertDialog}
            message={confirmAlertDialogMetas?.message}
            title={confirmAlertDialogMetas?.title}
            positiveBtnLable={confirmAlertDialogMetas?.positiveBtnLable}
            negativeBtnLable={confirmAlertDialogMetas?.negativeBtnLabel}
            handleClose={() => {
              setOpenConfirmAlertDialog(false);
              handleModalClose();
            }}
            handlePositiveClose={() => {
              unlockSmartLocketDevice(selectedDevices);
              setOpenConfirmAlertDialog(false);
            }}
            handleNegativeClose={() => {
              setOpenConfirmAlertDialog(false);
              handleModalClose();
            }}
          />

          {openDialog && (
            <UnlockDeviceMessageDialog
              open={openDialog}
              handleClose={() => {
                setOpenDialog(false);
                handleModalClose();
              }}
              data={responseData}
            />
          )}
        </Box>
      </Modal>
    </Box>
  );
}
